import { v4 } from 'uuid';
import { CookieStorage } from './cookie-storage';

export class CookieHandler {
  storage: CookieStorage;
  constructor(private namespace: string, private document: Document) {
    this.storage = new CookieStorage(this.namespace, this.document);
  }

  private oneYearFromNow(): string {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    return date.toUTCString();
  }

  private updateCookie(key: string, value?: string, expires?: string) {
    if (value) {
      if (!this.isValidIdentifier(value)) throw new Error(`Invalid ${key} specified`);
      this.storage.set(key, value, expires);
      return value;
    }

    let cookie = this.storage.get(key);
    if (!cookie) {
      cookie = this.uuid();
      this.storage.set(key, cookie, expires);
      return cookie;
    }

    if (!this.isValidIdentifier(cookie)) throw new Error(`Invalid ${key} specified in the cookie`);
    this.storage.set(key, cookie, expires);
    return cookie;
  }

  uuid(): string {
    return v4();
  }

  sessionKey(value?: string): string {
    return this.updateCookie('sessionKey', value);
  }

  customerKey(value?: string): string {
    return this.updateCookie('customerKey', value, this.oneYearFromNow());
  }

  isValidIdentifier(uuid: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
  }
}
export const Cookies = new CookieHandler('apptus', document);
